import api from './client';

export const storeDashboardApi = {
  getMyStore: () => api.get('/store-dashboard/my-store'),
  getProducts: (params = {}) => api.get('/store-dashboard/products', { params }),
  createProduct: (data) => api.post('/store-dashboard/products', data),
  updateProduct: (productId, data) => api.put(`/store-dashboard/products/${productId}`, data),
  deleteProduct: (productId) => api.delete(`/store-dashboard/products/${productId}`),
  getOrders: (params = {}) => api.get('/store-dashboard/orders', { params }),
  getStatistics: () => api.get('/store-dashboard/statistics'),
  getPayouts: (params = {}) => api.get('/store-dashboard/payouts', { params }),
  updateSettings: (data) => api.put('/store-dashboard/settings', data),
  getShippingLabel: (orderId) => api.get(`/store-dashboard/orders/${orderId}/shipping-label`, { responseType: 'blob' }),
  updateOrderStatus: (orderId, status) => api.put(`/store-dashboard/orders/${orderId}/status?status=${status}`),
  getNotifications: () => api.get('/store-dashboard/notifications'),
};
